import React from 'react'
import { useStartAssessmentsCall } from 'queries/admin/coach/useStartAssessmentsCall'
import {
  VoiceAgentCallContext,
  type VoiceAgentCallContextState,
} from '../../../context/VoiceAgentCallContext'
import { useVoiceCallSession } from '../../../hooks/useVoiceCallSession'

type AssessmentsProviderProps = {
  shiftId: number
  children: React.ReactNode
}

export const AssessmentsProvider = ({
  shiftId,
  children,
}: AssessmentsProviderProps) => {
  const startCallMutation = useStartAssessmentsCall()
  const session = useVoiceCallSession({
    startCall: ({ transport }) =>
      startCallMutation.mutateAsync({ transport, shiftId }),
  })

  const value: VoiceAgentCallContextState = {
    state: {
      title: 'Assessments',
      callState: session.callState,
      callId: session.callId,
      error: session.error,
      isMuted: session.isMuted,
      transcript: session.transcript,
    },
    actions: {
      startCall: session.startCall,
      endCall: session.endCall,
      reset: session.reset,
      toggleMute: session.toggleMute,
    },
  }

  return (
    <VoiceAgentCallContext.Provider value={value}>
      {children}
    </VoiceAgentCallContext.Provider>
  )
}
